import React, { useEffect, useState } from 'react';
import httpClient from './api/httpClient';
import LoginPage from './components/LoginPage';
import VlessKeysPage from './components/VlessKeysPage';
import './styles.css';

const AUTH_TOKEN_STORAGE_KEY = 'notreen.authToken';
const SESSION_STORAGE_KEY = 'notreen.session';

function applyAuthToken(token) {
  if (token) {
    httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    return;
  }

  delete httpClient.defaults.headers.common.Authorization;
}

function readStoredSession() {
  const token = window.sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (!token) {
    return null;
  }

  applyAuthToken(token);

  try {
    const storedSession = JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_KEY) || '{}');
    return {
      token,
      expiresAt: storedSession.expiresAt || new Date().toISOString(),
      telegramId: storedSession.telegramId || 0,
      telegramUsername: storedSession.telegramUsername || '',
    };
  } catch {
    return {
      token,
      expiresAt: new Date().toISOString(),
      telegramId: 0,
      telegramUsername: '',
    };
  }
}

function storeSession(session) {
  window.sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, session.token);
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({
    expiresAt: session.expiresAt,
    telegramId: session.telegramId,
    telegramUsername: session.telegramUsername,
  }));
}

function clearStoredSession() {
  window.sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
  applyAuthToken('');
}

function App() {
  const [session, setSession] = useState(() => readStoredSession());

  useEffect(() => {
    const interceptorId = httpClient.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          clearStoredSession();
          setSession(null);
        }

        return Promise.reject(error);
      },
    );

    return () => httpClient.interceptors.response.eject(interceptorId);
  }, []);

  const handleLogin = async ({ code }) => {
    const response = await httpClient.post('/api/identity/login', { code });
    storeSession(response.data);
    applyAuthToken(response.data.token);
    setSession(response.data);
  };

  const handleLogout = () => {
    clearStoredSession();
    setSession(null);
  };

  return session
    ? <VlessKeysPage session={session} onLogout={handleLogout} />
    : <LoginPage onLogin={handleLogin} />;
}

export default App;
